'use strict';

module.exports = {
    showDrawer: function () {
        $(document).on('click', '.country-selector', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $drawer = $('#country-selector-drawer-modal');
            var $contentContainer = $('#country-selector-content-container');

            // Check if drawer content is already loaded
            var isContentLoaded = $drawer.children('.country-selector-content').length > 0;

            // Store scroll position once to prevent scroll jump
            if (!$('body').data('scroll-top')) {
                var scrollTop = $(window).scrollTop();
                $('body').css('top', '-' + scrollTop + 'px').data('scroll-top', scrollTop);
            }

            // If drawer content doesn't exist, copy it from the hidden container
            if (!isContentLoaded && $contentContainer.length > 0 && $drawer.length > 0) {
                // Clone content from hidden container and append to drawer
                var content = $contentContainer.html();
                if (content && content.trim()) {
                    $drawer.html(content);
                }
            }

            // Create Bootstrap backdrop if it doesn't exist
            if ($('.modal-backdrop').length === 0) {
                $('body').append('<div class="modal-backdrop fade show"></div>');
            }

            // Open the drawer
            $drawer.addClass('drawer-open');
            $('body').addClass('drawer-open');
        });
    },

    hideDrawer: function () {
        /**
         * Closes the country selector drawer and restores scroll position
         */
        function closeDrawer() {
            var $drawer = $('.country-selector-drawer');
            $drawer.removeClass('drawer-open');
            $('body').removeClass('drawer-open');

            // Remove Bootstrap backdrop only if no other Bootstrap modals are open
            // (Bootstrap modals use body.modal-open, our drawer uses body.drawer-open)
            if (!$('body').hasClass('modal-open')) {
                $('.modal-backdrop').remove();
            }

            // Restore scroll position once
            var scrollTop = $('body').data('scroll-top');
            if (scrollTop !== undefined) {
                $('body').css('top', '').removeData('scroll-top');
                $(window).scrollTop(scrollTop);
            }
        }

        // Handle Bootstrap backdrop click/touch
        $(document).on('click touchend', '.modal-backdrop', function (e) {
            // The geolocation drawer owns its own backdrop handling.
            if ($(e.target).hasClass('geo-location-backdrop')) {
                return;
            }
            // Only close if drawer is open (to avoid conflicts with other modals)
            if ($('body').hasClass('drawer-open')) {
                e.preventDefault();
                e.stopPropagation();
                closeDrawer();
            }
        });

        // Handle close button and outside clicks
        $(document).on('click touchend', function (e) {
            // Don't close if clicking inside the form, on form elements, or on submit button
            const isFormClick = $(e.target).closest('form.country-selector-form').length > 0;
            const isSubmitButton = $(e.target).is('button[type="submit"]') || $(e.target).closest('button[type="submit"]').length > 0;
            if (isFormClick || isSubmitButton) {
                return;
            }

            // Ignore the geolocation drawer entirely; it manages its own close
            // logic in geoLocationPopup.js.
            if ($(e.target).closest('.geo-location-drawer').length) {
                return;
            }

            const isCloseButton = $(e.target).closest('.country-selector-drawer .close-button').length;
            const isBackdropClick = $(e.target).hasClass('modal-backdrop') && !$(e.target).hasClass('geo-location-backdrop');
            const isOutsideClick = $('body').hasClass('drawer-open')
                && !$(e.target).closest('.country-selector-drawer').length
                && !$(e.target).closest('.geo-location-drawer').length
                && !$(e.target).closest('.country-selector').length;

            if (isCloseButton || isBackdropClick || isOutsideClick) {
                closeDrawer();
            }
        });
    },

    initCustomDropdowns: function () {
        // Handle dropdown trigger clicks
        $(document).on('click', '.country-selector-dropdown-trigger', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const dropdownName = $(this).data('dropdown');
            const $menu = $('.country-selector-dropdown-menu[data-dropdown-menu="' + dropdownName + '"]');
            const $allMenus = $('.country-selector-dropdown-menu');

            // Close all other dropdowns
            $allMenus.not($menu).addClass('d-none');

            // Toggle current dropdown
            $menu.toggleClass('d-none');
        });

        // Handle dropdown option clicks
        $(document).on('click', '.country-selector-dropdown-option', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $option = $(this);
            const $menu = $option.closest('.country-selector-dropdown-menu');
            const dropdownName = $menu.data('dropdown-menu');
            const value = $option.data('value');
            const text = $option.find('.option-text').text().trim();
            const currencyCode = $option.data('currency-code');

            // Update selected option
            $menu.find('.country-selector-dropdown-option').removeAttr('data-selected').find('.checkmark').text('');
            $option.attr('data-selected', 'true').find('.checkmark').text('✓');

            // Update trigger text
            $('.country-selector-dropdown-trigger[data-dropdown="' + dropdownName + '"]')
                .find('.country-selector-dropdown-selected').text(text);

            // Update hidden select
            const $select = $('#' + dropdownName + '-select');
            $select.val(value);
            if (currencyCode) {
                $select.find('option[value="' + value + '"]').attr('data-currency-code', currencyCode);
            }
            $select.trigger('change');

            // Close dropdown
            $menu.addClass('d-none');
        });

        // Close dropdowns when clicking outside
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.country-selector-dropdown-wrapper').length) {
                $('.country-selector-dropdown-menu').addClass('d-none');
            }
        });

        // Keyboard accessibility
        $(document).on('keydown', '.country-selector-dropdown-trigger', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });

        $(document).on('keydown', '.country-selector-dropdown-option', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    },

    submitCountrySelectorForm: function () {
        // Handle form submission using delegated events for dynamically loaded content
        $(document).on('submit', 'form.country-selector-form', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let form = $(this);

            // Get values directly from custom dropdowns with data-selected="true"
            const countryValue = form.find('.country-selector-dropdown-menu[data-dropdown-menu="country"] .country-selector-dropdown-option[data-selected="true"]').data('value');
            const languageValue = form.find('.country-selector-dropdown-menu[data-dropdown-menu="language"] .country-selector-dropdown-option[data-selected="true"]').data('value');
            const currencyCode = form.find('.country-selector-dropdown-menu[data-dropdown-menu="country"] .country-selector-dropdown-option[data-selected="true"]').data('currency-code');

            if (!countryValue || !languageValue) {
                return false;
            }

            let action = $('.page').data('action');
            let localeCode = languageValue + '_' + countryValue;
            let queryString = $('.page').data('querystring');
            let url = form.attr('action');

            // Show spinner inside the drawer content
            $('.country-selector-drawer').spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: {
                    code: localeCode,
                    queryString: queryString,
                    CurrencyCode: currencyCode,
                    action: action
                },
                success: function (response) {
                    $('.country-selector-drawer').spinner().stop();
                    if (response && response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    }
                },
                error: function () {
                    $('.country-selector-drawer').spinner().stop();
                }
            });
            return false;
        });

        // Also handle button click/touch for mobile compatibility using delegated events
        $(document).on('click touchend', 'form.country-selector-form button[type="submit"]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let form = $(this).closest('form.country-selector-form');
            if (form.length === 0) {
                return false;
            }
            form.trigger('submit');
            return false;
        });
    }
};
